export default "__VITE_ASSET__gCTSuGmT__"